import React from 'react';
import { useIntl } from 'react-intl';
import { Button } from '../Button/Button.esm.js';
import '@panwds/icons';
import '@panwds/tailwindcss';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';
import '../Button/ProgressButton.esm.js';
import '../Button/CopyButton.esm.js';
import { ConfirmationDialog } from './ConfirmationDialog.esm.js';

const CloseConfirmation = ({ onCancel, onDiscard }) => {
    const intl = useIntl();
    return (React.createElement(ConfirmationDialog, { actions: React.createElement(React.Fragment, null,
            React.createElement(Button, { onClick: onCancel }, intl.formatMessage({
                defaultMessage: 'Cancel',
                id: 'GiKY8T',
                description: 'Label for button to cancel discarding changes'
            })),
            React.createElement(Button, { onClick: onDiscard, focusOnMount: true, appearance: "secondary-destructive" }, intl.formatMessage({
                defaultMessage: 'Discard',
                id: 'm/o7O7',
                description: 'Label for button to confirm discarding changes'
            }))), prompt: intl.formatMessage({
            defaultMessage: 'You have unsaved changes. Are you sure you want to proceed?',
            id: 'Adu5MF',
            description: 'Confirmation prompt to discard changes to the current form'
        }), title: intl.formatMessage({
            defaultMessage: 'Discard Changes?',
            id: 'ltXBo9',
            description: 'Confirmation prompt to discard changes to the current form'
        }) }));
};

export { CloseConfirmation };
//# sourceMappingURL=CloseConfirmation.esm.js.map
